import React, { Component } from 'react'
import { Modal } from 'antd'
import QuoteLineForm from './QuoteLineForm'
import FooterButtons from '../../../../elements/Buttons/FooterButtons'
import { AddQuoteContext } from '../../../../components/Sales/Quotes/AddQuote/AddQuoteCont'
import { Tabs } from 'antd'
import LinesHistory from '../../../../components/Sales/Quotes/AddQuote/LinesHistory'
import VendorLinesHistory from '../../../../components/Sales/Quotes/AddQuote/VendorLinesHistory'
import _ from 'lodash'

function QuoteLineModal() {
  const {
    visibleLine,
    submittingLine,
    onCancelLine,
    submitLine,
    updateLine,
    lineFormRef,
    removeLine,
    removingLine,
    isNew,
    isUpdatable,
    line,
  } = React.useContext(AddQuoteContext)
  return (
    <Modal
      visible={visibleLine}
      title={isNew ? 'Add Line' : 'Edit Line'}
      onCancel={onCancelLine}
      destroyOnClose={true}
      footer={
        <FooterButtons
          visible={isUpdatable}
          remove={removeLine}
          removing={removingLine}
          submit={submitLine}
          update={updateLine}
          submitting={submittingLine}
          title={'Quote Line'}
          isNew={isNew}
          isEdit={!isNew}
        />
      }
      width={'75%'}>
      <Tabs>
        <Tabs.TabPane key={'details'} tab={'Details'}>
          <QuoteLineForm ref={lineFormRef} />
        </Tabs.TabPane>
        <Tabs.TabPane disabled={_.get(line, 'isHeader', false)} key={'client-history'} tab={'Client History'}>
          <LinesHistory line={line} />
        </Tabs.TabPane>
        <Tabs.TabPane key={'vendor-history'} tab={'Vendor History'}>
          <VendorLinesHistory line={line} />
        </Tabs.TabPane>
      </Tabs>
    </Modal>
  )
}

QuoteLineModal.propTypes = {}
QuoteLineModal.defaultProps = {}

export default QuoteLineModal
